import { MessageResourceTypeMappings } from '@aa/nest/resource';
import { formatDateTime, formatUSD } from '@aa/ts/common';
import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  HostBinding,
  Input,
  signal,
} from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { Store } from '@ngrx/store';
import { CoreAppState } from '../../state/core-app.state';
import { orderCardActions } from '../../state/order-card/order-card.actions';

type ChangeApprovalMetadata = {
  orderCardId: number;
  addedServices: { id: number; name: string; price: number }[];
  removedServices: { id: number; name: string; price: number }[];
  status: 'pending' | 'approved' | 'rejected' | 'stale';
};

@Component({
  selector: 'aa-chat-message',
  standalone: true,
  imports: [CommonModule, MatButtonModule],
  templateUrl: './chat-message.component.html',
  styleUrl: './chat-message.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChatMessageComponent {
  @HostBinding('class.sender') isSender: boolean = false;

  @Input() message!: MessageResourceTypeMappings['resourceWithRelationsT'];
  @Input() isStaffApp = false;
  @Input() showTime = true;
  @Input() showRead = false;

  actionLoading = signal(false);

  formatMessageTimestamp = formatDateTime;
  formatUSD = formatUSD;

  get isChangeApprovalRequest() {
    return (this.message as any).messageType === 'change_approval_request';
  }

  get changeMetadata(): ChangeApprovalMetadata | null {
    const metadata = (this.message as any).metadata;
    if (!metadata) return null;
    return metadata as ChangeApprovalMetadata;
  }

  constructor(private readonly store: Store<CoreAppState>) {}

  approve() {
    const meta = this.changeMetadata;
    if (!meta || this.actionLoading()) return;
    this.actionLoading.set(true);
    this.store.dispatch(
      orderCardActions.approveCardChanges({
        orderCardId: meta.orderCardId,
        messageId: this.message.id,
        metadata: meta,
      }),
    );
  }

  reject() {
    const meta = this.changeMetadata;
    if (!meta || this.actionLoading()) return;
    this.actionLoading.set(true);
    this.store.dispatch(
      orderCardActions.rejectCardChanges({
        orderCardId: meta.orderCardId,
        messageId: this.message.id,
        metadata: meta,
      }),
    );
  }
}
